"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
/**
 * @owner fanhu <fanhu@microsoft.com>
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DotnetBuildDriverImpl = exports.DotnetBuildDriver = void 0;
const tslib_1 = require("tslib");
const baseBuildDriver_1 = require("./baseBuildDriver");
const typedi_1 = require("typedi");
const hooks_1 = require("@feathersjs/hooks");
const addStartAndEndTelemetry_1 = require("../middleware/addStartAndEndTelemetry");
const commonConstant_1 = require("../../constant/commonConstant");
const baseBuildStepDriver_1 = require("./baseBuildStepDriver");
const localizeUtils_1 = require("../../../common/localizeUtils");
const ACTION_NAME = "cli/runDotnetCommand";
let DotnetBuildDriver = class DotnetBuildDriver extends baseBuildStepDriver_1.BaseBuildStepDriver {
    description = (0, localizeUtils_1.getLocalizedString)("driver.script.dotnetDescription");
    getImpl(args, context) {
        return new DotnetBuildDriverImpl(args, context, "https://aka.ms/teamsfx-actions/cli-run-dotnet-command");
    }
    execute(args, ctx) {
        return super.execute(args, ctx);
    }
};
exports.DotnetBuildDriver = DotnetBuildDriver;
tslib_1.__decorate([
    (0, hooks_1.hooks)([(0, addStartAndEndTelemetry_1.addStartAndEndTelemetry)(ACTION_NAME, commonConstant_1.TelemetryConstant.SCRIPT_COMPONENT)]),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], DotnetBuildDriver.prototype, "execute", null);
exports.DotnetBuildDriver = DotnetBuildDriver = tslib_1.__decorate([
    (0, typedi_1.Service)(ACTION_NAME)
], DotnetBuildDriver);
class DotnetBuildDriverImpl extends baseBuildDriver_1.BaseBuildDriver {
    buildPrefix = "dotnet";
}
exports.DotnetBuildDriverImpl = DotnetBuildDriverImpl;
//# sourceMappingURL=dotnetBuildDriver.js.map